import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller'
import { SecondaryTextXs, TextArea } from 'atoms';
import internalState from './internalState';
import { MakeReadyItemCellWrapper, Td, GenericWrapper, RelativeWrapper, MakeReadyTextInputCellWrapper, Px2, WordBreakWrapper } from 'wrappers';
import { textEllipsis } from 'utils/ellipsis';


export const definition = {
  name: 'TextInputCell',
  controller: Controller,
  initialProps: ({ data, displayConfetti, showCheckboxes }) => ({ displayConfetti, data, inputValue: data?.data ?? '', showCheckboxes }),
  props: internalState,
  elements: [
    {
      wrapper: RelativeWrapper,
      name: 'RelativeWrapper',
      renderIf: ({ selectedRow }) => !selectedRow,
      ref: ({ containerRef, isOpen }) => isOpen ? containerRef : null,
      elements: [
        {
          wrapper: MakeReadyItemCellWrapper,
          name: 'Selector',
          renderIf: ({ displayConfetti }) => !displayConfetti,
          isButton: true,
          bindings: ({ data, isOpen, containerRef, inputRef, showCheckboxes }) => ({ data, isOpen, containerRef, inputRef, showCheckboxes }),
          displayState: ({ showCheckboxes }) => ({ background: showCheckboxes ? '#F7F7F7' : '' }),
          elements: [
            {
              component: wrap(wrap(SecondaryTextXs, WordBreakWrapper), Px2),
              name: 'Text',
              displayValue: ({ inputValue }) => textEllipsis(inputValue, 30)
            },

          ]
        },
        {
          wrapper: MakeReadyTextInputCellWrapper,
          name: "DropdownWrapper",
          renderIf: ({ isOpen }) => isOpen,
          displayState: ({ isOpen }) => ({ isOpen, top: '-21px', left: '-30px' }),
          ref: ({ containerRef }) => containerRef,
          elements: [
            {
              wrapper: GenericWrapper,
              name: 'InputWrapper',
              renderIf: ({ isOpen }) => isOpen,
              ref: ({ inputRef }) => inputRef ?? null,
              elements: [
                {
                  component: TextArea,
                  name: 'Input',
                  displayState: ({ }) => ({ fontSize: '12px', width: '160px', height: '100px' }),
                  bindings: ({ inputValue }) => ({ value: inputValue, placeholder: 'Insert text here...' })
                },
              ]
            },
          ]
        }
      ]
    }
  ]
}

export default wrap(ContainerComponent(definition), Td)